import { jwtDecode } from 'jwt-decode';
import { getToken } from '../http';

export const getCompanyIdFromToken = () => {
  try {
    const token = getToken();
    if (!token) return null;
    const decoded = jwtDecode(token);
    return decoded.CompanyTypeID;
  } catch (error) {
    console.error('Error decoding JWT:', error);
    return null;
  }
};

export const getCompanyTypeService = (companyTypeIdChecker) => {
  const companyTypeId = getCompanyIdFromToken();
  if (companyTypeId === null || companyTypeId !== companyTypeIdChecker) {
    return false;
  }
  if (companyTypeId === companyTypeIdChecker) {
    return true;
  }
};

export default {
  getCompanyTypeService,
};
